import { EventTypes } from "../eventtype.model";

export const AllDataEvents: any[] = [
  {
    label: "User Sessions by Store",
    name: "vv_user_session_start",
    events: ["vv_user_session_start", "vv_user_session_start_banter","vv_session_start"],
  },
  {
    label: "Total Virtual Try-On Sessions",
    name: "vv_vto_show_request",
    events: [
      "vv_vto_show_request",
      "vv_vto_show_request_banter",
      "vv_vto_show_request_ab_test",
      "vv_vto_nav_show_request",
      "vv_vto_nav_show_request_ab_test",
      "vv_vto_nav_show_request_banter",
    ],
  },
  {
    label: "Total Pictures Taken",
    name: "vv_vto_image_taken",
    events: [
      "vv_vto_image_taken",
      "vv_vto_image_taken_ab_test",
      "vv_vto_image_taken_banter",
    ],
  },
  {
    label: "Total Product Views",
    name: "vv_product_select",
    events: [
      "vv_product_select",
      "vv_product_select_ab_test",
      "vv_product_select_banter",
    ],
  },
  {
    label: "Media Tap",
    name: "media_tap",
    events: ["vv_media_tap"],
  },
  {
    label: "Total Social Media Requests",
    name: "curalate_show_request",
    events: [
      "curalate_show_request",
      "curalate_item_product_request",
      "curalate_item_show_request",
      "curalate_show_request_banter",
      "curalate_show_request_ab_test",
      "curalate_nav_show_request",
      "curalate_nav_show_request_ab_test",
      "curalate_nav_show_request_banter",
    ],
  },
  {
    label: "Total Social Media Image Views",
    name: "curalate_item_click",
    events: [
      "curalate_item_click",
      "curalate_item_click_ab_test",
      "curalate_item_click_banter",
      "curalate_item_show_request"
    ],
  },
  {
    label: "Total Social Media Item Views",
    name: "curalate_product_item_click",
    events: [
      "curalate_product_item_click",
      "curalate_product_item_click_ab_test",
      "curalate_product_item_click_banter",
      "curalate_item_product_request"
    ],
  },
  {
    label: "AOS Toggled",
    name: "vv_aos_toggle",
    events: [
      "vv_aos_toggle"
    ],
  },
  {
    label: "Tutorials Opened",
    name: "vv_tutorial_open",
    events: [
      "vv_tutorial_open"
    ],
  },
];
